


import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { EleWorkDDLAPI, EleWorkSubTypeDDLAPI} from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const ElEWorkNameDDL = (props) => {
    const { WorkType, WorkSubType,WorkNameType, setWorkNameType, rowData, Flag, IsPost, IsDisabled, ApiFlag, ActiveBtn, isDisplay } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_ELEC_WorkTypeID : WorkType?.ID != undefined ? WorkType?.ID :'0',
            M_ELEC_WorkSubTypeID : WorkSubType?.ID != undefined ? WorkSubType?.ID :'0',
            Flag: ApiFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(EleWorkDDLAPI({ data }))
    }, [IsPost && IsPost, WorkType?.ID, WorkSubType?.ID])

    const { WorkTypeData } = useSelector(state => state.EleWorkDDLData)


    useEffect(() => {
        handleWorkTypeDDL()
    }, [WorkTypeData])

    const handleWorkTypeDDL = () => {
        if (WorkTypeData && WorkTypeData.table && WorkTypeData.table.length > 0) {
            let list = WorkTypeData.table.map((item, index) => ({
                value: item.m_eleC_WorkID,
                label: item.workName,
            }))

            setWorkNameType({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_eleC_WorkID : 0,
                Label: Flag === 'Update' ? rowData.workName : "Select ...",
            })

        }
        else {
            setWorkNameType({
                DDL: [],
                ID: 0,
                Label: "Select ...",
            })
        }

    }

    return (
        <div className="form-group">
            {
                (isDisplay && isDisplay == true) &&
                <label className="d-block" htmlFor="NameofWorkType"><b>Work Name {Flag && <AstricSign />} </b></label>
            }
            <Select
                isClearable
                // isRtl={isRtl}
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                className=""
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkNameType.ID, label: WorkNameType.Label }}
                onChange={(e) => {
                    e ?
                        setWorkNameType({ ...WorkNameType, ID: e.value, Label: e.label })
                        :
                        setWorkNameType({ ...WorkNameType, ID: 0, Label: "Select WorkNameType" })
                }}
                options={WorkNameType.DDL}
            />
        </div>
    )
}